import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import EmissoesLista from '../componentsPage/EmissaoLista';


export default function ModalEmissaoVencer(props: any) {

    const { cliente_id, dias } = props



    return (

        <div>

            <Modal
                
                //show={show}
                //fullscreen={true}
                //onHide={() => setShow(false)}
                //style={{ height: "auto" }}
                size="xl"
                show={props.show}
                onHide={() => props.setShow(false)}
                aria-labelledby="example-modal-sizes-title-xl"
                >
                <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-xl">

                    
                        Emissões a vencer em {dias} dias



                </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                            
                            
                    <EmissoesLista origem="emissaoAVencer" dias={dias} cliente_id={cliente_id} />
                            


                </Modal.Body>
               

            </Modal>

        </div>

    )

}
